// ══════════════════════════════════════════════════════════
// terms-of-service.component.ts
// ══════════════════════════════════════════════════════════
import { Component } from "@angular/core"
import { ActivatedRoute, RouterLink } from "@angular/router"

@Component({
    selector: "hs-terms-of-service",
    standalone: true,
    imports: [RouterLink],
    templateUrl: "./terms-of-service.component.html",
    styleUrl: "./terms-of-service.component.scss",
})
export class TermsOfServiceComponent {
    readonly currentYear = new Date().getFullYear()

    constructor(public route: ActivatedRoute) {
        this.route.fragment.subscribe(this.navToFragment)
    }

    navToFragment(fragment: string) {
        if (fragment) {
            const element = document.getElementById(fragment)
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth" })
                }, 0)
            }
        }
    }
}
